export enum EXPRESS_ENVIRONMENT {
  production = 'production',
  staging = 'staging',
  development = 'development'
}

export enum DeliveryOption {
  INSTANT = 'instant',
  SCHEDULED = 'scheduled'
}
